<template>
	<div
		class="it"
		:style="
			isShowPartner
				? `--table-cols:
						minmax(150px, 1fr)
						minmax(120px, 0.7fr)
						minmax(130px, 1fr)
						minmax(450px, 1fr)
						minmax(150px, 1fr)
						minmax(150px, 1fr)
						minmax(150px, 1fr);`
				: `--table-cols:
						minmax(120px, 0.7fr)
						minmax(130px, 1fr)
						minmax(450px, 1fr)
						minmax(150px, 1fr)
						minmax(150px, 1fr)
						minmax(150px, 1fr);`
		"
	>
		<div class="it__t">
			<!-- /////////////// -->
			<!-- Партнёр -->
			<div v-if="isShowPartner" class="it__t-head">
				<UiDropdownFilter
					label="Партнёр"
					:items="items.partners"
					v-on:filter="onPartnerFilter"
				/>
			</div>

			<!-- /////////////// -->
			<!-- Канал -->
			<div class="it__t-head">
				Канал
			</div>

			<!-- /////////////// -->
			<!-- Номер -->
			<div class="it__t-head">
				<UiInputFilter label="Номер" v-on:filter="onInstanceFilter" />
			</div>

			<!-- /////////////// -->
			<!-- Токен -->
			<div class="it__t-head">
				<UiInputFilter label="Токен" v-on:filter="onTokenFilter" />
			</div>

			<!-- /////////////// -->
			<!-- Телефон -->
			<div class="it__t-head">
				<UiInputFilter label="Телефон" v-on:filter="onPhoneFilter" />
			</div>

			<!-- /////////////// -->
			<!-- Статус -->
			<div class="it__t-head">
				<UiDropdownFilter
					label="Статус"
					:items="statusFilterItems"
					:is-show-icon="false"
					v-on:filter="onStatusFilter"
				/>
			</div>

			<!-- /////////////// -->
			<!-- Срок действия инстанса -->
			<template v-if="isShowPartner">
				<div class="it__t-head">
					<UiDropdownFilter
						label="Дата создания"
						dropdown-default-label="Без сортировки"
						:items="sortItems"
						:is-show-icon="false"
						v-on:filter="onInsertOrder"
					/>
				</div>
			</template>
			<template v-else>
				<div class="it__t-head">
					<UiDropdownFilter
						label="Срок действия"
						dropdown-default-label="Без сортировки"
						:items="expiredFilterItems"
						:is-show-icon="false"
						v-on:filter="onExpireOrder"
					/>
				</div>
			</template>
		</div>

		<!-- /////////////// -->
		<!-- Table body -->
		<div
			:class="notify(item) ? 'it__t it__t_notify' : 'it__t'"
			v-for="(item, index) in items.list"
			:key="index"
		>
			<div v-if="isShowPartner" class="it__t-body">
				{{ item.partner }}
			</div>
			<div class="it__t-body">
				{{ formatChannel(item.sourceName, item.channel) }}
			</div>
			<div
				class="it__t-body it__instance-detail"
				@click="
					onClickRedirect(
						'instance-detail',
						item.instance,
						item.channel
					)
				"
			>
				{{ item.instance }}
			</div>
			<div class="it__t-body">{{ item.token }}</div>
			<div class="it__t-body">{{ formatPhoneNumber(item.phone) }}</div>
			<div class="it__t-body">
				<UiStatusIndicator :value="item.status" />
			</div>
			<div
				:class="{
					'it__t-body': true,
					'it__t-body_notify': notify(item) && !isShowPartner,
				}"
			>
				<template v-if="isShowPartner">
					{{ dataTimeFormat(item.insertStamp, true) }}
				</template>
				<template v-else-if="hasExpirePaymentStamp(item.expirePaymentStamp)">
					до {{ dataTimeFormat(item.expirePaymentStamp) }}
				</template>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { IInstance } from "@/interfaces/IInstance";
import UiStatusIndicator from "@/components/ui/UiStatusIndicator.vue";
import IconSearch from "@/components/icons/IconSearch.vue";
import IconChevronDown from "@/components/icons/IconChevronDown.vue";
import UiDropdownFilter from "@/components/ui/UiDropdownFilter.vue";
import UiInputFilter from "@/components/ui/UiInputFilter.vue";
import dayjs from "dayjs";
import "dayjs/locale/ru";
dayjs.locale("ru");

@Options({
	components: {
		UiInputFilter,
		UiDropdownFilter,
		IconChevronDown,
		IconSearch,
		UiStatusIndicator,
	},
	props: {
		items: { type: Object, default: {} },
		channel: { type: String, default: "wapi" },
	},
})
export default class InstanceTable extends Vue {
	public items: IInstance;
	public channel: string;
	public timeId = 0;

	// Filters
	public page = 1;
	public partnerId = 0;
	public instanceId = "";
	public token = "";
	public phone = "";
	public statusId = "";

	// Ordering
	public expireOrder = "";
	public insertOrder = "";

	/**
	 * Переходит в карточку инстанса и сохраняет канал в query.
	 */
	public onClickRedirect(routeName: string, id?: number, channel?: string) {
		// Канал передаем в URL, чтобы деталка открыла инстанс из правильной БД.
		this.$router.push({
			name: routeName,
			params: { id: id },
			query: { channel: channel || "" },
		});
	}

	/**
	 * Скрываем или показываем колонку в таблице
	 * Возвращает true если больше 0
	 * Возвращает false если 0
	 */
	public get isShowPartner(): boolean {
		if (this.items.partners?.length !== undefined) {
			return this.items.partners?.length !== 0;
		}

		return false;
	}

	/**
	 * Форматирование номера телефона
	 * Возвращает строку такого вида: +7 (914) 234-34-50
	 * @param num
	 */
	public formatPhoneNumber(num: string | null) {
		if (num !== null) {
			return num.replace(
				/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/g,
				`+$1 ($2) $3-$4-$5`
			);
		} else {
			return "";
		}
	}

	/**
	 * Удаляет ненужные символы из номера телефона
	 * Возвращает строку такого вида: 79142343450
	 * @param num
	 */
	public toSourcePhoneNumber(num: string) {
		const regExp = /\*|[()]|\+|-|\s|\$/g;

		return num.replace(regExp, "");
	}

	/**
	 * Обработка фильтра - Партнёр
	 * @param id
	 */
	public async onPartnerFilter(id: number) {
		this.page = 1;
		this.partnerId = id;
		await this.performRequest();
	}

	/**
	 * Обработка фильтра - id инстанса
	 * @param id
	 */
	public async onInstanceFilter(id: string) {
		this.page = 1;
		this.instanceId = id;

		clearTimeout(this.timeId);
		this.timeId = setTimeout(async () => {
			await this.performRequest();
		}, 500);
	}

	/**
	 * Обработка фильтра - token
	 * @param id
	 */
	public async onTokenFilter(id: string) {
		this.page = 1;
		this.token = id;

		clearTimeout(this.timeId);
		this.timeId = setTimeout(async () => {
			await this.performRequest();
		}, 500);
	}

	/**
	 * Обработка фильтра - phone
	 * @param num
	 */
	public async onPhoneFilter(num: string) {
		this.page = 1;
		this.phone = this.toSourcePhoneNumber(num);

		clearTimeout(this.timeId);
		this.timeId = setTimeout(async () => {
			await this.performRequest();
		}, 500);
	}

	/**
	 * Обработка фильтра - status
	 * @param id
	 */
	public async onStatusFilter(id: string) {
		this.page = 1;
		this.statusId = id;
		await this.performRequest();
	}

	/**
	 * Обработка сортировки для поля - expire_payment_stamp
	 * all, asc, desc
	 * @param id
	 */
	public async onExpireOrder(id: string) {
		this.expireOrder = id;
		this.page = 1;
		await this.performRequest();
	}

	/**
	 * Обработка сортировки для поля - insert_stamp
	 * all, asc, desc
	 * @param id
	 */
	public async onInsertOrder(id: string) {
		this.insertOrder = id;
		this.page = 1;
		await this.performRequest();
	}

	/**
	 * Выполняем запрос
	 */
	public async performRequest() {
		const query = {
			page: this.page,
			partnerId: this.partnerId,
			instanceId: this.instanceId,
			token: this.token,
			phone: this.phone,
			statusId: this.statusId,
			// Активный канал приходит из вкладки родительской страницы.
			channel: this.channel,
			expireOrder: this.expireOrder,
			insertOrder: this.insertOrder,
		};

		this.$emit("selected-filters", query);
	}

	public statusFilterItems = [
		{
			id: 1,
			name: "Активен",
		},
		{
			id: 2,
			name: "Ожидание",
		},
		{
			id: 6,
			name: "Остановлен",
		},
		{
			id: 10,
			name: "Удалён",
		},
	];

	/**
	 * Возвращает человекочитаемое название канала для таблицы.
	 */
	public formatChannel(sourceName: string, channel: string) {
		if (sourceName) {
			return sourceName;
		}

		return (channel || "").toUpperCase();
	}

	public expiredFilterItems = [
		{
			id: 1,
			name: "Истекающие",
		},
		{
			id: 2,
			name: "Недавние",
		},
	];

	public sortItems = [
		{
			id: 1,
			name: "По возрастанию",
		},
		{
			id: 2,
			name: "По убыванию",
		},
	];

	/**
	 * Форматируем timestamp к виду - 15 августа 10:00
	 * @param timestamp
	 * @param withYear
	 */
	public dataTimeFormat(timestamp: number, withYear = false) {
		if (!this.hasExpirePaymentStamp(timestamp)) {
			return "";
		}

		const dateTemplate = withYear ? "DD MMMM YYYY HH:mm" : "DD MMMM HH:mm";
		return dayjs(timestamp).format(dateTemplate);
	}

	/**
	 * Проверяет, что срок действия инстанса заполнен и его можно показывать.
	 */
	public hasExpirePaymentStamp(timestamp: number | null | undefined) {
		return Boolean(timestamp);
	}

	/**
	 * Подсветка истёкших и истикающих каналов
	 * Если expired меньше за offset - тогда делаем выделение
	 * Если expired больше за offset - ничего не выделяем
	 * @param item
	 */
	public notify(item: {
		expirePaymentStamp: number;
		notificationOffset: number;
	}): boolean {
		const notificationOffset = item.notificationOffset;
		const expirePaymentStamp = item.expirePaymentStamp;

		if (!this.hasExpirePaymentStamp(expirePaymentStamp)) {
			return false;
		}

		const offset = dayjs().add(notificationOffset, "days").unix();
		return expirePaymentStamp < offset * 1000;
	}
}
</script>

<style scoped lang="scss">
.it {
	padding: 8px 24px;

	&__t {
		display: grid;
		grid-template-columns: var(--table-cols);
		background: rgb(252, 252, 252);
		border: 1px solid rgb(219, 219, 219);
		border-bottom: 0;
	}

	&__t_notify {
		background: #f5f5f5;
	}

	&__t:first-child {
		border: 1px solid rgb(219, 219, 219);
		border-top-left-radius: 12px 12px;
		border-top-right-radius: 12px 12px;
		border-bottom: 0;
	}

	&__t:last-child {
		border: 1px solid rgb(219, 219, 219);
		border-bottom-left-radius: 12px 12px;
		border-bottom-right-radius: 12px 12px;
	}

	&__t-head {
		color: rgb(119, 121, 124);
		font-size: 16px;
		border-right: 1px solid rgb(219, 219, 219);
		padding: 22px;
	}

	&__t-head:last-child {
		border-right: 0;
	}

	&__t-head-search {
		display: flex;
	}

	&__t-head-search-icon {
		margin-right: 10px;
	}

	&__t-body {
		display: flex;
		color: rgb(34, 34, 34);
		font-size: 16px;
		border-right: 1px solid rgb(219, 219, 219);
		padding: 14px;
		align-items: center;
	}

	&__t-body_notify {
		color: #ff8585;
	}

	&__t-body:last-child {
		border-right: 0;
	}

	&__instance-detail {
		cursor: pointer;
		color: #1f8fff;
	}
}
</style>
